<!--
  File name: DbnStatusTable.vue
  Program Description:
    - This component renders the table list for all existing DBN Status

  Includes:
    - CrudTable: used to fetch the list of dbn status and renders it to a list
-->
<template>
  <v-container flex>
    <CrudTable
      ref="crudTable"
      v-bind="{
        bulkDelete:false,
        meta
      }"
      @editRow="editRow"
      @modalChange="modalChange"
    />
  </v-container>
</template>

<script>
import crud from '@/utils/rest/crud'
import validationErrors from '@/utils/validations/errors'
import { validationMixin } from 'vuelidate'
import table from '@/meta/mdTable/crudModules/dbnStatus/table'
import { privilegeMixin } from 'session-plugin'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'DbnStatusTable',
  components: {
  },
  mixins: [
    privilegeMixin,
    validationMixin
  ],
  data: () => ({
    modal: false,
    readOnly: false,
    loading: false,
    action: 'create',
    formItems: {
      _id: '',
      value: ''
    }
  }),
  computed: {
    ...validationErrors,
    meta () {
      return table
    },
    schema () {
      return {
        value: this.formItems.value
      }
    },
    modalHeader () {
      if (this.action === 'create') {
        return 'Add DBN Status'
      } else {
        return 'DBN Status Details'
      }
    }
  },
  methods: {
    // remove selection of item
    // populate main table and subtable
    async populateTable () {
      await this.$refs.crudTable.populateTable()
    },
    // setup edit and shows edit dialog
    async editRow (action, _id) {
      this.formItems._id = _id
      this.action = action
      this.readOnly = false
      await this.view()
      this.modal = !this.modal
    },
    // setup create and view dialog
    async modalChange (action, _id = '') {
      if (action === 'create') {
        this.formItems.value = ''
        this.$v.$reset()
      }
      this.formItems._id = _id
      this.action = action
      action === 'create' ? (this.readOnly = false) : (this.readOnly = true)
      action === 'view' && await this.view()
      this.modal = !this.modal
    },
    // fetch data from database for selected item
    async view () {
      const data = await this.api('read').read(this.formItems._id, '', true)
      this.formItems = { ...this.formItems, ...data.entry }
    },
    // input 'dbnStatus' to crud (imported)
    api (action) {
      return crud('dbnStatus')
    },
    // trigger validation
    // if valid, show confirmation dialog for create or update action
    validate (operation) {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (operation === 'create') {
          this.$store.dispatch('showDialog', {
            title: 'Add DBN Status',
            message: 'Are you sure you want to add this DBN Status?',
            buttonLabel: 'Add',
            buttonColor: 'primary',
            callback: () => this.save(operation)
          })
        } else {
          this.$store.dispatch('showDialog', {
            title: 'Update DBN Status',
            message: 'Are you sure you want to update this DBN Status?',
            buttonLabel: 'Update',
            buttonColor: 'primary',
            callback: () => this.save(operation)
          })
        }
      }
    },
    // trigger saveItem with specific action prop
    async save (operation) {
      if (operation === 'create') {
        await this.saveItem('create')
      } else {
        await this.saveItem('update')
      }
      this.loading = false
    },
    // trigger api for either create or update depending on action prop
    async saveItem (action) {
      this.loading = true
      const payloadResp = action === 'create' ? await this.api('create').create(this.schema) : await this.api('update').update(this.formItems._id, this.schema)
      const payloadJson = await payloadResp.json()
      this.modal = false
      this.triggerAlert({ success: payloadResp.ok, action, data: payloadJson })
    },
    // show alert dialog for success message or error message
    async triggerAlert ({ success, action, data }) {
      if (success) {
        const createMessage = `${this.formItems.value} has been successfully added!`
        const updateMessage = `${this.formItems.value} has been successfully updated!`
        this.$store.dispatch('showAlert', {
          message: action === 'create' ? createMessage : updateMessage,
          type: 'success'
        })
        this.readOnly = true
        await this.populateTable()
      } else {
        this.$store.dispatch('showAlert', {
          message: data.error || data.message,
          type: 'error'
        })
      }
      this.loading = false
    },
    // show confirmation dialog for delete
    checkDelete (callback) {
      this.$store.dispatch('showDialog', {
        title: 'Delete DBN Status',
        message: 'Are you sure that you want to delete this DBN Status? This action cannot be undone.',
        buttonLabel: 'Delete',
        callback: () => { this.deleteItem(callback) }
      })
    },
    // delete selected item
    // show alert with either a success message or error message
    async deleteItem (callback) {
      this.modal = false
      this.loading = true
      const resp = await this.api('delete').delete(this.formItems._id)
      this.loading = false
      if (resp.ok) {
        this.$store.dispatch('showAlert', {
          message: 'DBN Status successfully deleted',
          type: 'success'
        })
        await this.populateTable()
      } else {
        this.$store.dispatch('showAlert', {
          message: (await resp.json()).error,
          type: 'error'
        })
      }
    }
  },
  validations () {
    return {
      formItems: {
        value: { required }
      }
    }
  }
}
</script>
